module.exports = __webpack_public_path__ + "img/dev_devnagri123g.749022c.png";